import { useState } from "react";

import Close from "../../assets/close.svg";
import { useEscape } from "../../hooks/useEscape";
import DropDown from "../../formComponents/DropDown";
import InlineInput from "../../formComponents/InlineInput";
import FormButton from "../../formComponents/FormButton";
import { GenerateFscTemplate } from "../../funcs/download/generateFscTemplate";

export default function CreateFscTemplate({ setDownloadFscTemplateTrigger }) {
  const [pending, setPending] = useState(false);
  const [templateParams, setTemplateParams] = useState({
    method_id: 0,
    diesel_steps: 0,
    diesel_start: 0,
    diesel_step_size: 0,
    mileage_steps: 0,
  });
  const methodOptions = [
    { value: 7, label: "Per ST" },
    { value: 8, label: "Flat" },
    { value: 40, label: "Per Mile" },
  ];

  const handleClose = () => {
    setDownloadFscTemplateTrigger(false);
  };

  useEscape(setDownloadFscTemplateTrigger);

  const handleMethod = (o) => {
    setTemplateParams({
      ...templateParams,
      method_id: o.value,
    });
  };
  const handleChange = (e) => {
    setTemplateParams({
      ...templateParams,
      [e.target.name]: e.target.value,
    });
  };

  const handleDownload = async (e) => {
    e.preventDefault()
    setPending(true)
    await GenerateFscTemplate(templateParams)
    setPending(false)
    setDownloadFscTemplateTrigger(false)
  };
  
  return (
    <div className="popup">
      <div className="popup-inner">
        {!pending && (
          <div>
            <img
              className="close"
              onClick={handleClose}
              src={Close}
              alt="close img"
            />
          </div>
        )}
        <div className="mb-5 info">
          <h4>Generate FSC Template</h4>
        </div>
        <form onSubmit={handleDownload}>
          <DropDown
            title="Hauling Method"
            name="method_id"
            options={methodOptions}
            placeholder="Select Method"
            required={true}
            value={
              templateParams.method_id !== 0
                ? methodOptions.filter(
                    (o) => o.value === templateParams.method_id,
                  )[0]
                : null
            }
            onChange={handleMethod}
          />
          {(templateParams.method_id === 7 ||
            templateParams.method_id === 8) && (
            <InlineInput
              divClass="mb-1 row field"
              classname="col-sm-4 col-form-label fw-bold"
              inputClass="col-sm-6"
              title="Mileage Steps"
              type="number"
              name="mileage_steps"
              value={templateParams.mileage_steps}
              required={true}
              onChange={handleChange}
            />
          )}
          {templateParams.method_id !== 0 && (
            <>
              <InlineInput
                divClass="mb-1 row field"
                classname="col-sm-4 col-form-label fw-bold"
                inputClass="col-sm-6"
                title="Diesel Steps"
                type="number"
                name="diesel_steps"
                value={templateParams.diesel_steps}
                required={true}
                onChange={handleChange}
              />
              <InlineInput
                divClass="mb-1 row field"
                classname="col-sm-4 col-form-label fw-bold"
                inputClass="col-sm-6"
                title="Diesel Start $"
                type="number"
                step={0.001}
                name="diesel_start"
                value={templateParams.diesel_start}
                required={true}
                onChange={handleChange}
              />
              <InlineInput
                divClass="mb-1 row field"
                classname="col-sm-4 col-form-label fw-bold"
                inputClass="col-sm-6"
                title="Diesel Step Size $"
                type="number"
                step={0.001}
                name="diesel_step_size"
                value={templateParams.diesel_step_size}
                required={true}
                onChange={handleChange}
              />
            </>
          )}
          <FormButton pending={pending} name={"Generate"}/>
        </form>
      </div>
    </div>
  );
}
